import { Input } from '@easyv/react-components';
import { SearchOutlined } from '@easyv/react-icons';
import React from 'react';
import { Updater } from 'use-immer';
import { SelectedCategoryType } from '../..';

export interface OfficialAssetContentBannerProps {
  workingFolder: SelectedCategoryType | null;
  setContentQuery: Updater<string>;
}

export function OfficialAssetContentBanner(props: OfficialAssetContentBannerProps) {
  const { workingFolder, setContentQuery } = props;

  return (
    <div className='mx-6 mt-4 h-7 flex justify-between'>
      <div className='text-white flex items-center text-sm'>{workingFolder?.name}</div>
      <div>
        <Input
          allowClear
          prefix={<SearchOutlined className='anticon' size={16} />}
          placeholder='搜索资产'
          className='!w-[200px]'
          size='small'
          maxLength={32}
          onChange={(e) => {
            setContentQuery(e);
          }}
        />
      </div>
    </div>
  );
}
